import { render, staticRenderFns } from "./RouterLinkToCardColumnTemplate.vue?vue&type=template&id=e61acb9a"
import script from "./RouterLinkToCardColumnTemplate.vue?vue&type=script&lang=js"
export * from "./RouterLinkToCardColumnTemplate.vue?vue&type=script&lang=js"
import style0 from "./RouterLinkToCardColumnTemplate.vue?vue&type=style&index=0&id=e61acb9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports